import {
  IconClipboardList,
  IconClock,
  IconCheck,
  IconProgress,
  IconX,
  IconCalendarDue,
} from '@tabler/icons-react';
import type { FilterPreset } from '@/components/ui/FilterModal';
import type { AuditFilter } from './AuditFilterContent';

export function getAuditFilterPresets(): FilterPreset<AuditFilter>[] {
  return [
    {
      id: 'all-audits',
      name: 'All Audits',
      description: 'Complete list of all audits',
      icon: <IconClipboardList size={20} />,
      color: 'blue',
      filters: {},
      badge: 'Popular',
    },
    {
      id: 'in-progress',
      name: 'In Progress',
      description: 'Currently ongoing audits',
      icon: <IconProgress size={20} />,
      color: 'blue',
      filters: { status: 'in_progress' },
    },
    {
      id: 'completed',
      name: 'Completed Audits',
      description: 'Successfully completed audits',
      icon: <IconCheck size={20} />,
      color: 'green',
      filters: { status: 'completed' },
    },
    {
      id: 'draft',
      name: 'Draft Audits',
      description: 'Audits not yet started',
      icon: <IconClock size={20} />,
      color: 'gray',
      filters: { status: 'draft' },
    },
    {
      id: 'cancelled',
      name: 'Cancelled',
      description: 'Audits that were cancelled',
      icon: <IconX size={20} />,
      color: 'red',
      filters: { status: 'cancelled' },
    },
    {
      id: 'recent-audits',
      name: 'Recent Audits',
      description: 'Audits from last 30 days',
      icon: <IconCalendarDue size={20} />,
      color: 'violet',
      filters: {
        dateRange: {
          start: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000),
          end: new Date(),
        },
      },
    },
  ];
}
